import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Col, Row } from 'react-grid-system';
import H1 from '../../atoms/title/H1';
import Panel from '../../atoms/Panel';
import Layout from '../../templates/Layout';
import SideBar from '../../organisms/dossier/SideBar';
import InvoiceTable from '../../organisms/table/InvoiceTable';
import Tabs from '../../organisms/dossier/Tabs';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
const Invoices = ({ dossierNumber, invoices, dossier, }) => {
    const { t } = useTranslation();
    return (_jsxs(Layout, { dossierNumber: dossierNumber, "data-testid": "dossier-invoices", children: [_jsx(Helmet, { children: _jsxs("title", { children: ["Facturen - ", t('dossier.title')] }) }), _jsxs(H1, { "data-testid": "title", children: [t('dossier.title'), " ", dossierNumber] }), _jsxs(Row, { children: [_jsx(Col, { sm: 9, children: _jsxs(Panel, { children: [_jsx(Tabs, { dossier: dossier }), _jsx(InvoiceTable, { invoices: invoices })] }) }), _jsx(Col, { sm: 3, children: _jsx(SideBar, { dossier: dossier }) })] })] }));
};
export default Invoices;
